export const actionTypes = {
    SET_FILTER: 'SET_FILTER',
    SET_INVALID_STATE: 'SET_INVALID_STATE',
    SET_PERFORMANCE_TABULAR_VIEW: 'SET_PERFORMANCE_TABULAR_VIEW'
}